'use client'

import { useEffect } from 'react'

type Props = {
  locale: string
  postId: string
}

export function PostViewTracker({ locale, postId }: Props) {
  useEffect(() => {
    const controller = new AbortController()

    void fetch('/api/view-stats', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ locale, postId }),
      signal: controller.signal,
    }).catch(() => {
      // Ignore tracking failures so they never affect page rendering.
    })

    return () => {
      controller.abort()
    }
  }, [locale, postId])

  return null
}
